module.exports = __webpack_public_path__ + "static/media/gtt-thewall-2.7c24560d.svg";